import React from 'react';
import { Link } from 'react-router-dom';
import './Credentials.css';

const team = [
  {
    name: 'Afzal Khan',
    title: 'Founder & Lead IT Engineer',
    photo: '/images/afzal-khan.png',
    bio: `Afzal Khan is the Founder and Lead IT Engineer at Bluepeak. With over a decade of experience, he bridges business strategy with hands-on systems architecture—specializing in scalable cloud infrastructure (AWS/Azure/GCP), DevOps automation, and enterprise cybersecurity.
    Afzal turns complex technology into secure, streamlined systems designed for high-growth businesses.`,
    certifications: [
      'CompTIA A+',
      'Cisco Packet Tracing',
    ],
    specializations: ['Managed IT Services', 'Cybersecurity', 'Law Firm IT', 'Endpoint Management'],
    linkedin: 'https://www.linkedin.com/in/afzal-khan/',
  },
  {
    name: 'Bilal Mir',
    title: 'IT Infrastructure & Security Specialist',
    photo: '/images/bilal-mir.png',
    bio: `Bilal brings deep hands-on expertise across enterprise infrastructure and security operations. 
    He has led mobile device enrolment programs, managed hardware inventory at scale, and handled full server rack 
    replacements end-to-end — from procurement and IP/subnet configuration through to physical installation. 
    His active directory experience spans setup, configuration, and complex domain migrations. On the security side, 
    Bilal conducts penetration testing and vulnerability management engagements, and builds the risk analyses and 
    policy frameworks that keep organizations audit-ready.`,
    certifications: [
      'AZ-104 Microsoft Azure Administrator',
      'Microsoft Certified: Security Operations Analyst Associate',
    ],
    specializations: [
      'Mobile Device Enrolment',
      'Server Infrastructure',
      'Active Directory',
      'Penetration Testing',
      'Vulnerability Management',
      'Risk & Policy',
    ],
    linkedin: 'https://www.linkedin.com/in/bilal-mir-116139123/',
  },
];

const values = [
  {
    title: 'Transparency first',
    desc: "You will always know what we're doing, why we're doing it, and what it costs. No surprise invoices.",
  },
  {
    title: 'Regulated-industry fluent',
    desc: 'We understand privilege, confidentiality, and compliance. We speak your language.',
  },
  {
    title: 'Documentation-driven',
    desc: 'Every action we take is logged, documented, and available to you. Audit-ready by default.',
  },
  {
    title: 'Small team, full accountability',
    desc: "When you call Bluepeak, you get the person who did the work — not a ticket number.",
  },
];

export default function Credentials() {
  return (
    <div className="credentials-page">
      <div className="page-hero">
        <div className="container">
          <span className="tag">Credentials</span>
          <h1>The team behind Bluepeak.</h1>
          <p>
            A focused, senior team. Every member hands-on, accountable, and reachable.
          </p>
        </div>
      </div>

      <div className="container cred-layout section">

        <div className="team-section">
          {team.map((member) => (
            <div key={member.name} className="founder-card">
              <div className="founder-avatar">
                <img
                  src={member.photo}
                  alt={member.name}
                  className="avatar-photo"
                />
              </div>
              <div className="founder-info">
                <h2>{member.name}</h2>
                <p className="founder-title">{member.title}</p>
                <p className="founder-bio">{member.bio}</p>

                <div className="founder-specs">
                  <div className="spec-block">
                    <h4>Specializations</h4>
                    <div className="tag-list">
                      {member.specializations.map(s => (
                        <span key={s} className="spec-tag">{s}</span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="inline-certs">
                  <h4>Certifications</h4>
                  <div className="inline-certs-grid">
                    {member.certifications.map(cert => (
                      <div key={cert} className="cert-card">
                        <span className="cert-badge">✓</span>
                        <span className="cert-name">{cert}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-outline linkedin-btn"
                >
                  View LinkedIn Profile ↗
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="values-section">
          <span className="tag">How we work</span>
          <h2>The Bluepeak standard.</h2>
          <div className="values-grid">
            {values.map(v => (
              <div key={v.title} className="value-card">
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="cred-cta">
          <h2>Let's talk about your environment.</h2>
          <p>A 30-minute call is all it takes to understand where you stand.</p>
          <Link to="/contact" className="btn-primary">Book a Consultation →</Link>
        </div>
      </div>
    </div>
  );
}
